import type { SupplierRequestListObjectType, SupplierRequestType } from '@econtractor/types';
import EmptyResult from 'components/others/EmptyResult';
import SupplierRequestsTableRow from './SupplierRequestsTableRow';

interface SupplierRequestsTableBodyProps {
    requests: SupplierRequestType[];
    canOps: boolean;
    onOpen: (requestId: number) => void;
    onClone: (row: SupplierRequestType) => void;
    onChanged: () => void;
    onSendEmail: (row: SupplierRequestType) => void;
    onFilterByObject: (object: SupplierRequestListObjectType) => void;
}

const SupplierRequestsTableBody = ({
    requests,
    canOps,
    onOpen,
    onClone,
    onChanged,
    onSendEmail,
    onFilterByObject,
}: SupplierRequestsTableBodyProps) => {
    if (!requests.length) {
        return (
            <tbody>
                <tr>
                    <td colSpan={7}>
                        <EmptyResult />
                    </td>
                </tr>
            </tbody>
        );
    }

    return (
        <tbody>
            {requests.map((row) => (
                <SupplierRequestsTableRow
                    key={row.ID}
                    row={row}
                    canOps={canOps}
                    onOpen={onOpen}
                    onClone={onClone}
                    onChanged={onChanged}
                    onSendEmail={onSendEmail}
                    onFilterByObject={onFilterByObject}
                />
            ))}
        </tbody>
    );
};

export default SupplierRequestsTableBody;
